import { render } from "./TopDownViewer.vue?vue&type=template&id=9bd04ed0&scoped=true"
import script from "./TopDownViewer.vue?vue&type=script&lang=js"
export * from "./TopDownViewer.vue?vue&type=script&lang=js"

import "./TopDownViewer.vue?vue&type=style&index=0&id=9bd04ed0&scoped=true&lang=css"

import exportComponent from "/home/oat/Desktop/ordi/corridor_v2/corridor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bd04ed0"]])

export default __exports__